import React from 'react';
import { WorkflowStatusId, WorkflowStatusLabel } from 'types/enums/WorkflowStatus';
import './WorkflowStatusText.scss';

const CLASS_BY_STATUS: Partial<Record<WorkflowStatusId, string>> = {
  [WorkflowStatusId.FREIGEGEBEN]: 'psf-workflow-status--green',
  [WorkflowStatusId.ZUR_FREIGABE_VORGELEGT]: 'psf-workflow-status--blue',
  [WorkflowStatusId.ZURUECKGEWIESEN]: 'psf-workflow-status--red',
};

const workflowStatusClass = (statusId?: number): string =>
  CLASS_BY_STATUS[statusId as WorkflowStatusId] ?? '';

export const workflowStatusLabel = (statusId?: number): string =>
  statusId ? WorkflowStatusLabel[statusId as WorkflowStatusId] || 'Unbekannt' : '-';

interface IProps {
  statusId?: number;
  className?: string;
}

/** The workflow state as coloured text, the way the drawings list shows it. */
export const WorkflowStatusText: React.FC<IProps> = ({ statusId, className = '' }) => (
  <span className={`psf-workflow-status ${workflowStatusClass(statusId)} ${className}`}>{workflowStatusLabel(statusId)}</span>
);
